import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

// 📌 Définition des offres
const offers = [
  {
    title: "Landing Page",
    price: "À partir de 80.000 CFA",
    features: [
      "1 page optimisée pour convertir",
      "Design moderne & responsive",
      "Hébergement & SEO de base",
    ],
  },
  {
    title: "Site Vitrine",
    price: "À partir de 120.000 CFA",
    features: [
      "Jusqu’à 4 pages",
      "Formulaire de contact intégré",
      "Optimisation SEO & mobile",
    ],
  },
];

// 🎭 Animation des cartes
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Offers = () => {
  return (
    <div className="container-fluid py-5" id="services">
      <div className="">
        {/* Titre */}
        <motion.h1
          className="text-center mb-5 "
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          Des solutions adaptées à votre budget et vos besoins.
        </motion.h1>

        {/* Mapping des offres */}
        <div className="row justify-content-center pt-5">
          {offers.map((offer, index) => (
            <motion.div
              key={index}
              className="col-lg-5 col-md-6 mb-4"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div
                className="card rounded-4 shadow-md p-4 border-0 offer-card"
                style={{ minHeight: "200px" }}
              >
                <h2 className="fw-bold mb-3 text-center">{offer.title}</h2>
                <h3 className="blue-color text-center">{offer.price}</h3>
                <ul className="list-unstyled mt-3">
                  {offer.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className="d-flex align-items-center text-black"
                    >
                      <FaCheckCircle className="text-success me-2" /> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        {/* 📩 CTA */}
        <motion.div
          className="text-center mt-5"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="fw-bold">
            Besoin d’un site sur mesure ? Contactez-moi !
          </h4>
          <motion.button
            className="btn btn-primary rounded-pill px-4 py-2 "
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <a
              target="blank"
              className="text-decoration-none white-color"
              href="https://tally.so/r/m6vN5o"
            >
              Demandez un devis
            </a>
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default Offers;
